import changelogNo from '../resources/no/changelog.json';
import changelogSe from '../resources/se/changelog.json';
import { ChangelogLanguageResources } from '../types/ChangelogLanguageResources';

export const changelogI18nResources: ChangelogLanguageResources = {
  no: { changelog: changelogNo },
  se: { changelog: changelogSe },
};
